export default __webpack_public_path__ + "static/media/lab-test.2d845d1f.svg";